"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center'
});
const Loading = exports.Loading = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            color: "primary",
            "aria-label": formatMessage('loading')
        })
    });
});
